import theme from 'src/styles/theme'
import styled from 'styled-components'

export const Container = styled.section`
  display: flex;
  flex-direction: column;
`

export const Info = styled.div`
  align-self: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 10rem;

  h2 {
    color: ${theme.colors.confirm};
  }

  p {
    font-size: 1rem;
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  width: 50%;
`

export const ButtonAgain = styled.button`
  border: 1px solid #c7c9c7;
  border-radius: 4px;
  color: white;
  background-color: ${theme.colors.confirm};
  font-weight: bold;
  padding: 1rem;
  min-width: 6rem;
`

export const ButtonBack = styled(ButtonAgain)`
  background-color: ${theme.colors.blue};
`
